// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('p2ReleaseNote', {
//         templateUrl: 'views/components/views/p2ReleaseNote/p2ReleaseNote.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['stateService', 'utilityService', 'p2ReleaseNoteService', 'rememberService', 'layoutService', function (stateService, utilityService, p2ReleaseNoteService, rememberService, layoutService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let tabletSize = layoutService.getMediaQueries().tablet;
            
//             let variableNames = {
//                 searchtext: ''
//             };

//             vm.model = {
//                 tabletSize: tabletSize,
//                 itemState: '',
//                 p2ReleaseNoteKeyno: '',
//                 searchTextButtons: [
//                     { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('searchtext') }
//                 ],
//                 setting: {},
//                 itemsListReleaseNotes: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTIONS

//             let loadSetting = function () {
//                 p2ReleaseNoteService.getReleaseNoteSettings().then(function (info) {
//                     angular.copy(info[0], vm.model.setting);
//                 });
//             };

//             let loadReleaseNotes = function () {
//                 vm.model.itemsListReleaseNotes = [];

//                 p2ReleaseNoteService.listReleaseNotes().then(function (list) {
//                     angular.copy(list, vm.model.itemsListReleaseNotes);

//                     angular.forEach(vm.model.itemsListReleaseNotes, function (item) {
//                         if (item.item_state > '') {
//                             vm.model.itemState = item.item_state;
//                         }
//                     });
//                 });
//             };

//             // #endregion LOAD PROCEDURE FUNCTIONS

//             // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             let rememberFunc = function (id) {
//                 angular.forEach(variableNames, function (_, key) {
//                     variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                 });

//                 if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                 let variableValue = null;

//                 switch (id) {
//                     case 'searchtext':
//                         if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                         variableValue = vm.model.setting[id];
//                         break;
//                     default:
//                         break;
//                 }

//                 return rememberService.remember(variableNames[id], variableValue);
//             };

// 		    // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             // #region UPDATE PROCEDURE LIST FUNCTION

//             vm.updateReleaseNotes = function () {
//                 vm.model.p2ReleaseNoteKeyno = '';
//                 loadReleaseNotes();
//             };

//             // #endregion UPDATE PROCEDURE LIST FUNCTION

//             // #region LIST DIRECTION BUTTON FUNCTION

//             vm.openReleaseNote = function (item) {
//                 vm.model.p2ReleaseNoteKeyno = item.item_id;
//             };

//             // #endregion LIST DIRECTION BUTTON FUNCTION

//             // #region RESET BUTTON FUNCTION

//             let reset = function (id) {
//                 switch (id) {
//                     case 'searchtext':
//                         vm.model.setting.searchtext = '';

//                         if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                         break;
//                     default:
//                         break;
//                 }
//             };

// 		    // #endregion RESET BUTTON FUNCTION

//             // #region MULTI DIRECTION BUTTON FUNCTIONS

//             vm.goToFunc = function (state, e) {
//                 let go = function (parms) {
//                     if (e?.ctrlKey) {
//                         stateService.newTab(state, parms);
//                     } else {
//                         stateService.go(state, parms);
//                     }
//                 };

//                 switch (state) {
//                     case 'p2releasenoteedit':
//                         if (tabletSize.matches === true && vm.model.itemState === 'p2releasenoteedit') {
//                             vm.model.p2ReleaseNoteKeyno = '0';
//                         } else {
//                             go({ p2_releasenote_keyno: '0' });
//                         }
//                         break;
//                     default:
//                         break;
//                 }
//             };

// 		    // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//             // #region ON BLUR MULTI FUNCTIONS

//             vm.onBlur = function (id) {
//                 switch (id) {
//                     case 'searchtext':
//                         if (utilityService.validateParmsValue(vm.model.setting.searchtext) !== true) return;

//                         if (vm.model.setting.searchtext > '') rememberFunc('searchtext');
//                         break;
//                     default:
//                         break;
//                 }
//             };

// 		    // #endregion ON BLUR MULTI FUNCTIONS

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'searchtext':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                         vm.model.setting.searchtext = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                         if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

// 		    // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 loadSetting();
//                 loadReleaseNotes();
//             };

// 		    // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
